import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { useState } from "react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getPaymentAuthorizationList,
  ResetPaymentAuthorizationDataState,
} from "../../store/Slice/paymentAuthorizationSlice";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getbookNowDetailList } from "../../store/Slice/bookNowDetailSlice";
import {
  getPromoCodeListing,
  ResetPromoCodeState,
} from "../../store/Slice/promoCodeListingSlice";

const PaymentForm = ({ labelDetailData }) => {
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [cardDetails, setCardDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");

  const [formErrorMessage, setFormErrorMessage] = React.useState("");
  // const [continueLoading, setContinueLoading] = React.useState(false);
  const [cardholderName, setCardholderName] = useState("");
  const [couponCode, setCouponCode] = useState("");
  const [cardholderNameError, setCardholderNameError] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [isCouponChecked, setIsCouponChecked] = useState(false);
  const [isCheckedError, setIsCheckedError] = useState("");
  const [couponCodeError, setCouponCodeError] = useState("");
  const [showDiscountText, setShowDiscountText] = useState(false);

  const [applyButtonClicked, setApplyButtonClicked] = React.useState(false);
  const [bookNowloading, setBookNowLoading] = React.useState(false);
  // const [discountedTotalAmountHome, setDiscountedTotalAmountHome] =
  //   React.useState("");
  const [discountHome, setDiscountHome] = React.useState("");
  const [discountedSubtotalHome, setDiscountedSubtotalHome] =
    React.useState("");
  const [discountedTotalHome, setDiscountedTotalHome] = React.useState("");
  const [taxHome, setTaxHome] = React.useState("");

  // const [discountedTotalAmountBookNow, setDiscountedTotalAmountBookNow] =
  //   React.useState("");
  const [discountBookNow, setDiscountBookNow] = React.useState("");
  const [discountedSubtotalBookNow, setDiscountedSubtotalBookNow] =
    React.useState("");
  const [discountedTotalBookNow, setDiscountedTotalBookNow] =
    React.useState("");

  const [taxBookNow, setTaxBookNow] = React.useState("");

  const { paymentAuthorizationData } = useSelector(
    (state) => state.paymentAuthorizationList
  );

  const { promoCodeListingData } = useSelector((state) => state.promoCodeList);

  const uniqueCode = sessionStorage.getItem("SameDayBookingId");
  const uniqueBookCode = sessionStorage.getItem("bookSameDayBookingId");

  const cityHome = sessionStorage.getItem("City");
  const cityBookNow = sessionStorage.getItem("bookCity");

  const bookSameDayBookingId = sessionStorage.getItem("bookSameDayBookingId");
  const bookCleningPrice = sessionStorage.getItem("bookFinalPrice");

  const totalAmount = sessionStorage.getItem("FinalPrice");
  const totalBookAmount = sessionStorage.getItem("bookFinalPrice");
  const CustomerEmail = sessionStorage.getItem("CustomerEmail");
  const CustomerPhone = sessionStorage.getItem("CustomerPhone");
  const tax = sessionStorage.getItem("Tax");
  const Price = sessionStorage.getItem("price");
  const finalPrice = sessionStorage.getItem("FinalPrice");

  const bookTax = sessionStorage.getItem("bookTax");
  const bookPrice = sessionStorage.getItem("bookPrice");
  const bookfinalPrice = sessionStorage.getItem("bookFinalPrice");

  const sameDayBookingIdValue = sessionStorage.getItem("SameDayBookingId");
  const CleningPrice = sessionStorage.getItem("FinalPrice");

  const handleNameChange = (event) => {
    const cardNameValue = event.target.value;
    setCardholderName(cardNameValue);

    event.target.value.trim() !== "" && setCardholderNameError("");

    if (cardNameValue.trim() === "" && cardNameValue.length === 0) {
      setCardholderNameError("Please enter the cardholder's name.");
    } else {
      setCardholderNameError("");
    }
  };

  const handleCouponcodeChange = (event) => {
    const couponCodeValue = event.target.value;
    setCouponCode(couponCodeValue);
  };

  const handleCheckboxChange = (event) => {
    const checked = event.target.checked;
    setIsChecked(checked);
    setIsCheckedError(checked ? "" : "Please accept the terms.");
  };

  const handleCouponCheckboxChange = (event) => {
    const couponChecked = event.target.checked;
    setIsCouponChecked(couponChecked);
  };

  React.useEffect(() => {
    if (!couponCode || !isCouponChecked) {
      setApplyButtonClicked(false);
      setCouponCodeError("");
      dispatch(ResetPromoCodeState());

      if (location.pathname === "/") {
        setDiscountHome("");
        setTaxHome("");
        setDiscountedTotalHome("");
      } else if (location.pathname === "/book-now") {
        setDiscountBookNow("");
        setTaxBookNow("");
        setDiscountedTotalBookNow("");
      }

      setShowDiscountText(false);
      if (!isCouponChecked) {
        setCouponCode(null);
      }
    }
  }, [couponCode, isCouponChecked, location, dispatch]);

  const ValidatePayForm = React.useCallback(() => {
    let isValid = true;

    setCardholderNameError("");

    if (cardholderName.trim() === "" && cardholderName.length === 0) {
      setCardholderNameError("Please enter the cardholder's name.");
      isValid = false;
    }
    if (!isChecked) {
      setIsCheckedError("Please accept the terms.");
      isValid = false;
    }
    if (isCouponChecked && !couponCode) {
      setCouponCodeError("Please Enter the Coupon Code.");
      isValid = false;
    }

    return isValid;
  }, [cardholderName, isChecked, isCouponChecked, couponCode]);

  React.useEffect(() => {
    const cardElement = elements.getElement(CardElement);
    if (!cardElement) return;

    const handleChange = (event) => {
      if (event.complete) {
        setErrorMessage("");
      }
    };

    cardElement.on("change", handleChange);

    return () => {
      cardElement.off("change", handleChange);
    };
  }, [elements]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) return;

    if (couponCode && !applyButtonClicked) {
      setCouponCodeError(
        "Please apply your coupon code first to receive your discount."
      );
      return;
    }

    const cardElement = elements.getElement(CardElement);

    const isValidForm = ValidatePayForm();
    if (isValidForm) {
      // Get card details
      const paymentMethod = await stripe.createPaymentMethod({
        type: "card",
        card: cardElement,
        billing_details: {
          name: cardholderName,
          email: CustomerEmail,
          phone: CustomerPhone,
        },
      });

      if (
        paymentMethod?.error ||
        (couponCode && promoCodeListingData?.code === 400)
      ) {
        setErrorMessage(paymentMethod?.error?.message);
        // setErrorMessage(promoCodeListingData?.message)
      } else {
        if (location.pathname === "/") {
          setCardDetails(paymentMethod);
          setErrorMessage("");
          setLoading(true);
          dispatch(
            getPaymentAuthorizationList({
              vUniqueCode: uniqueCode,
              amount:
                typeof discountedTotalHome === "number" && couponCode
                  ? discountedTotalHome
                  : totalAmount,
              currency: "cad",
              paymentMethodId: paymentMethod?.paymentMethod?.id,
              coupon_code: couponCode ? couponCode : "",
            })
          );
        } else if (location.pathname === "/book-now") {
          setErrorMessage("");
          setCardDetails(paymentMethod);

          setBookNowLoading(true);
          dispatch(
            getPaymentAuthorizationList({
              vUniqueCode: uniqueBookCode,
              amount:
                typeof discountedTotalBookNow === "number" && couponCode
                  ? discountedTotalBookNow
                  : totalBookAmount,
              currency: "cad",
              paymentMethodId: paymentMethod?.paymentMethod?.id,
              coupon_code: couponCode ? couponCode : "",
            })
          );
        }
      }
    }
  };

  React.useEffect(() => {
    if (location.pathname === "/") {
      if (paymentAuthorizationData && paymentAuthorizationData.code === 200) {
        dispatch(
          getbookNowDetailList({
            vUniqueCode: sameDayBookingIdValue,
            total_price:
              typeof discountedTotalHome === "number" && couponCode
                ? +discountedTotalHome
                : +CleningPrice,
          })
        );
        setLoading(false);
        dispatch(ResetPaymentAuthorizationDataState());
        navigate("/thank-you", {
          state: {
            pagePath: location.pathname,
          },
        });
      } else if (
        paymentAuthorizationData &&
        (paymentAuthorizationData.code === 404 ||
          paymentAuthorizationData.code === 400)
      ) {
        setLoading(false);
        setFormErrorMessage(paymentAuthorizationData.message);
      }
    } else if (location.pathname === "/book-now") {
      if (paymentAuthorizationData && paymentAuthorizationData.code === 200) {
        dispatch(
          getbookNowDetailList({
            vUniqueCode: bookSameDayBookingId,
            total_price:
              typeof discountedTotalBookNow === "number" && couponCode
                ? +discountedTotalBookNow
                : +bookCleningPrice,
          })
        );

        setBookNowLoading(false);
        dispatch(ResetPaymentAuthorizationDataState());
        navigate("/thank-you", {
          state: {
            pagePath: location.pathname,
          },
        });
      } else if (
        paymentAuthorizationData &&
        (paymentAuthorizationData.code === 404 ||
          paymentAuthorizationData.code === 400)
      ) {
        setFormErrorMessage(paymentAuthorizationData.message);

        setBookNowLoading(false);
      }
    }
  }, [
    couponCode,
    dispatch,
    paymentAuthorizationData,
    location.pathname,
    CleningPrice,
    bookCleningPrice,
    bookSameDayBookingId,
    sameDayBookingIdValue,
    discountedTotalHome,
    discountedTotalBookNow,
    navigate,
  ]);

  React.useEffect(() => {
    if (couponCode) {
      setCouponCodeError("");
    }
  }, [couponCode]);

  const handleApplyButton = React.useCallback(() => {
    setApplyButtonClicked(true);
    setCouponCodeError("");

    if (!couponCode) {
      setCouponCodeError("Please Enter Coupon Code.");
    } else {
      setCouponCodeError("");
    }

    if (couponCode) {
      if (location.pathname === "/") {
        dispatch(
          getPromoCodeListing({
            vUniqueCode: uniqueCode,
            amount: +Price,
            coupon_code: couponCode,
            iCityId: +cityHome,
          })
        );
      } else if (location.pathname === "/book-now") {
        dispatch(
          getPromoCodeListing({
            vUniqueCode: uniqueBookCode,
            amount: +bookPrice,
            coupon_code: couponCode,
            iCityId: +cityBookNow,
          })
        );
      }
    }
  }, [
    location,
    dispatch,
    uniqueCode,
    Price,
    uniqueBookCode,
    bookPrice,
    couponCode,
    cityHome,
    cityBookNow,
  ]);

  React.useEffect(() => {
    if (location.pathname === "/" && isCouponChecked) {
      if (promoCodeListingData && promoCodeListingData.code === 200) {
        setShowDiscountText(true);
        setDiscountedSubtotalHome(promoCodeListingData?.Data?.SubTotal);
        setDiscountedTotalHome(promoCodeListingData?.Data?.Total);
        sessionStorage.setItem(
          "discountedHomeTotalAmount",
          promoCodeListingData?.Data?.Amount
        );
        setDiscountHome(promoCodeListingData?.Data?.Discount);
        setTaxHome(promoCodeListingData?.Data?.Tax);
      } else if (promoCodeListingData && promoCodeListingData.code === 400) {
        setCouponCodeError("This coupon code is invalid.");
      }
    } else if (location.pathname === "/book-now" && isCouponChecked) {
      if (promoCodeListingData && promoCodeListingData.code === 200) {
        setShowDiscountText(true);
        setDiscountedSubtotalBookNow(promoCodeListingData?.Data?.SubTotal);
        setDiscountedTotalBookNow(promoCodeListingData?.Data?.Total);
        sessionStorage.setItem(
          "discountedBookNowTotalAmount",
          promoCodeListingData?.Data?.amount
        );
        setDiscountBookNow(promoCodeListingData?.Data?.Discount);
        setTaxBookNow(promoCodeListingData?.Data?.Tax);
      } else if (promoCodeListingData && promoCodeListingData.code === 400) {
        setCouponCodeError("This coupon code is invalid.");
      }
    }
  }, [promoCodeListingData, isCouponChecked, location]);

  const labelMap = React.useMemo(() => {
    if (labelDetailData?.code === 200 && Array.isArray(labelDetailData.data)) {
      return new Map(
        labelDetailData.data.map((item) => [item.vLabel, item.tText])
      );
    }
    return new Map();
  }, [labelDetailData]);

  const paymentDetailsHeading =
    labelMap.get("LBL_HOME_PAYMENT_DETAILS_HEADING") || "";
  const cardHolderText = labelMap.get("LBL_HOME_CARD_HOLDER_NAME_TEXT") || "";
  const agreeCheckbox =
    labelMap.get("LBL_HOME_AGREE_WITH_MOPFORCE_CHECKBOX") || "";
  const termsConditionCheckbox =
    labelMap.get("LBL_HOME_TERMS_AND_CONDITIONS_CHECKBOX") || "";

  const amountText = labelMap.get("LBL_HOME_AMOUNT_TEXT") || "";
  const taxText = labelMap.get("LBL_HOME_TAX_TEXT") || "";
  const totalText = labelMap.get("LBL_HOME_TOTAL_TEXT") || "";

  const verifymessageDescription =
    labelMap.get("LBL_HOME_VERIFY_AND_CONFIRMATION_DESCRIPTION") || "";
  const verifyDescription = labelMap.get("LBL_HOME_VERIFY_DESCRIPTION") || "";
  const payingHeading = labelMap.get("LBL_HOME_YOU_ARE_PAYING_HEADING") || "";
  const serviceHeading =
    labelMap.get("LBL_HOME_FOR_THIS_SERVICE_HEADING") || "";

  const paymentDetailsBookNowHeading =
    labelMap.get("LBL_BOOK_NOW_PAYMENT_DETAILS_HEADING") || "";

  const cardHolderBookNowText =
    labelMap.get("LBL_BOOK_NOW_CARD_HOLDER_NAME_TEXT") || "";
  const agreeBookNowCheckbox =
    labelMap.get("LBL_BOOK_NOW_AGREE_WITH_MOPFORCE_CHECKBOX") || "";
  const termsConditionBookNowCheckbox =
    labelMap.get("LBL_BOOK_NOW_TERMS_AND_CONDITIONS_CHECKBOX") || "";

  const amountBookNowText = labelMap.get("LBL_BOOK_NOW_AMOUNT_TEXT") || "";
  const taxBookNowText = labelMap.get("LBL_BOOK_NOW_TAX_TEXT") || "";
  const totalBookNowText = labelMap.get("LBL_BOOK_NOW_TOTAL_TEXT") || "";

  const verifymessageBookNowDescription =
    labelMap.get("LBL_BOOK_NOW_VERIFY_AND_CONFIRMATION_DESCRIPTION") || "";

  const verifyBookNowDescription =
    labelMap.get("LBL_BOOK_NOW_VERIFY_DESCRIPTION") || "";
  const payingBookNowHeading =
    labelMap.get("LBL_BOOK_NOW_YOU_ARE_PAYING_HEADING") || "";
  const serviceBookNowHeading =
    labelMap.get("LBL_BOOK_NOW_FOR_THIS_SERVICE_HEADING") || "";

  return (
    <>
      <>
        <div className="row">
          <div className="col-lg-10 mx-auto">
            <form onSubmit={handleSubmit}>
              <div className="payment-form">
                <h3 className="main-title text-center">
                  {paymentDetailsHeading || paymentDetailsBookNowHeading}
                </h3>
                <div className="login-inputDiv">
                  <label className="form-label" htmlFor="cardholderName">
                    {cardHolderText || cardHolderBookNowText}
                  </label>
                  <input
                    type="text"
                    placeholder={cardHolderText || cardHolderBookNowText}
                    value={cardholderName}
                    onChange={handleNameChange}
                    className="form-control"
                  />
                  {cardholderNameError && (
                    <div className="validation-error">
                      {cardholderNameError}
                    </div>
                  )}
                </div>
                <div className="login-inputDiv mt-3">
                  <label className="form-label" htmlFor="cardholderName">
                    Card Number
                  </label>
                  <CardElement />
                  {errorMessage && (
                    <div className="validation-error">{errorMessage}</div>
                  )}
                </div>
                <div className="form-check mt-3">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="couponCheckbox"
                    checked={isCouponChecked}
                    onChange={handleCouponCheckboxChange}
                  />
                  <label
                    className="login-linkpara mb-0"
                    htmlFor="couponCheckbox"
                  >
                    Have a coupon code?
                  </label>{" "}
                </div>

                <div className="login-inputDiv mt-3">
                  {isCouponChecked && (
                    <div style={{ position: "relative" }}>
                      <input
                        type="text"
                        placeholder="Coupon Code"
                        value={couponCode}
                        onChange={handleCouponcodeChange}
                        className="form-control"
                      />
                      <button
                        type="button"
                        className="success-orangebtn"
                        style={{
                          position: "absolute",
                          top: "0",
                          right: "0",
                          borderTopLeftRadius: "0",
                          borderBottomLeftRadius: "0",
                          bottom: "0",
                        }}
                        onClick={handleApplyButton}
                      >
                        Apply
                      </button>
                    </div>
                  )}
                  {couponCodeError && (
                    <div className="validation-error">{couponCodeError}</div>
                  )}
                </div>

                <div className="book-time-sort">
                  <ul className="w-100">
                    <li>
                      <div className="d-flex align-items-md-center">
                        <div className="icon-list">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M9.7 11.3C9.3 10.9 8.7 10.9 8.3 11.3C7.9 11.7 7.9 12.3 8.3 12.7L11.3 15.7C11.5 15.9 11.7 16 12 16C12.3 16 12.5 15.9 12.7 15.7L19.7 7.70003C20 7.20003 20 6.60003 19.5 6.30003C19.1 6.00003 18.5 6.00003 18.2 6.40003L12 13.5L9.7 11.3Z"
                              fill="#FF6F00"
                            />
                            <path
                              d="M21 11C20.4 11 20 11.4 20 12C20 16.4 16.4 20 12 20C7.6 20 4 16.4 4 12C4 9.9 4.8 7.9 6.3 6.4C7.8 4.8 9.8 4 12 4C12.6 4 13.3 4.1 13.9 4.2C14.4 4.4 15 4.1 15.2 3.5C15.4 2.9 15 2.5 14.5 2.3H14.4C13.6 2.1 12.8 2 12 2C6.5 2 2 6.5 2 12.1C2 14.7 3.1 17.3 4.9 19.1C6.8 21 9.3 22 11.9 22C17.4 22 21.9 17.5 21.9 12C22 11.4 21.5 11 21 11Z"
                              fill="#FF6F00"
                            />
                          </svg>
                        </div>
                        <div className="sort-list-desc">
                          {amountText || amountBookNowText}{" "}
                          <span>
                            {" "}
                            ${location.pathname === "/" ? Price : bookPrice}
                          </span>
                        </div>
                      </div>
                    </li>
                    {showDiscountText && couponCode ? (
                      <>
                        <li>
                          <div className="d-flex align-items-md-center">
                            <div className="icon-list">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M9.7 11.3C9.3 10.9 8.7 10.9 8.3 11.3C7.9 11.7 7.9 12.3 8.3 12.7L11.3 15.7C11.5 15.9 11.7 16 12 16C12.3 16 12.5 15.9 12.7 15.7L19.7 7.70003C20 7.20003 20 6.60003 19.5 6.30003C19.1 6.00003 18.5 6.00003 18.2 6.40003L12 13.5L9.7 11.3Z"
                                  fill="#FF6F00"
                                />
                                <path
                                  d="M21 11C20.4 11 20 11.4 20 12C20 16.4 16.4 20 12 20C7.6 20 4 16.4 4 12C4 9.9 4.8 7.9 6.3 6.4C7.8 4.8 9.8 4 12 4C12.6 4 13.3 4.1 13.9 4.2C14.4 4.4 15 4.1 15.2 3.5C15.4 2.9 15 2.5 14.5 2.3H14.4C13.6 2.1 12.8 2 12 2C6.5 2 2 6.5 2 12.1C2 14.7 3.1 17.3 4.9 19.1C6.8 21 9.3 22 11.9 22C17.4 22 21.9 17.5 21.9 12C22 11.4 21.5 11 21 11Z"
                                  fill="#FF6F00"
                                />
                              </svg>
                            </div>
                            <div className="sort-list-desc">
                              Discount :
                              <span>
                                {" "}
                                {location.pathname === "/" ? (
                                  <>${discountHome} </>
                                ) : (
                                  <>${discountBookNow} </>
                                )}
                              </span>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="d-flex align-items-md-center">
                            <div className="icon-list">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M9.7 11.3C9.3 10.9 8.7 10.9 8.3 11.3C7.9 11.7 7.9 12.3 8.3 12.7L11.3 15.7C11.5 15.9 11.7 16 12 16C12.3 16 12.5 15.9 12.7 15.7L19.7 7.70003C20 7.20003 20 6.60003 19.5 6.30003C19.1 6.00003 18.5 6.00003 18.2 6.40003L12 13.5L9.7 11.3Z"
                                  fill="#FF6F00"
                                />
                                <path
                                  d="M21 11C20.4 11 20 11.4 20 12C20 16.4 16.4 20 12 20C7.6 20 4 16.4 4 12C4 9.9 4.8 7.9 6.3 6.4C7.8 4.8 9.8 4 12 4C12.6 4 13.3 4.1 13.9 4.2C14.4 4.4 15 4.1 15.2 3.5C15.4 2.9 15 2.5 14.5 2.3H14.4C13.6 2.1 12.8 2 12 2C6.5 2 2 6.5 2 12.1C2 14.7 3.1 17.3 4.9 19.1C6.8 21 9.3 22 11.9 22C17.4 22 21.9 17.5 21.9 12C22 11.4 21.5 11 21 11Z"
                                  fill="#FF6F00"
                                />
                              </svg>
                            </div>
                            <div className="sort-list-desc">
                              Subtotal :
                              <span>
                                {" "}
                                {location.pathname === "/" ? (
                                  <>${discountedSubtotalHome} </>
                                ) : (
                                  <>${discountedSubtotalBookNow} </>
                                )}
                              </span>
                            </div>
                          </div>
                        </li>
                      </>
                    ) : (
                      ""
                    )}
                    <li
                      // className={
                      //   isCouponChecked && couponCode && applyButtonClicked
                      //     ? ""
                      //     : "totalamount-list"
                      // }
                      className="totalamount-list"
                    >
                      <div className="d-flex align-items-md-center">
                        <div className="icon-list">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M9.7 11.3C9.3 10.9 8.7 10.9 8.3 11.3C7.9 11.7 7.9 12.3 8.3 12.7L11.3 15.7C11.5 15.9 11.7 16 12 16C12.3 16 12.5 15.9 12.7 15.7L19.7 7.70003C20 7.20003 20 6.60003 19.5 6.30003C19.1 6.00003 18.5 6.00003 18.2 6.40003L12 13.5L9.7 11.3Z"
                              fill="#FF6F00"
                            />
                            <path
                              d="M21 11C20.4 11 20 11.4 20 12C20 16.4 16.4 20 12 20C7.6 20 4 16.4 4 12C4 9.9 4.8 7.9 6.3 6.4C7.8 4.8 9.8 4 12 4C12.6 4 13.3 4.1 13.9 4.2C14.4 4.4 15 4.1 15.2 3.5C15.4 2.9 15 2.5 14.5 2.3H14.4C13.6 2.1 12.8 2 12 2C6.5 2 2 6.5 2 12.1C2 14.7 3.1 17.3 4.9 19.1C6.8 21 9.3 22 11.9 22C17.4 22 21.9 17.5 21.9 12C22 11.4 21.5 11 21 11Z"
                              fill="#FF6F00"
                            />
                          </svg>
                        </div>
                        <div className="sort-list-desc">
                          {taxText || taxBookNowText}{" "}
                          <span>
                            {" "}
                            $
                            {location.pathname === "/"
                              ? typeof taxHome === "number" && couponCode
                                ? taxHome
                                : tax
                              : typeof taxBookNow === "number" && couponCode
                              ? taxBookNow
                              : bookTax}
                          </span>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="d-flex align-items-md-center">
                        <div className="icon-list">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M9.7 11.3C9.3 10.9 8.7 10.9 8.3 11.3C7.9 11.7 7.9 12.3 8.3 12.7L11.3 15.7C11.5 15.9 11.7 16 12 16C12.3 16 12.5 15.9 12.7 15.7L19.7 7.70003C20 7.20003 20 6.60003 19.5 6.30003C19.1 6.00003 18.5 6.00003 18.2 6.40003L12 13.5L9.7 11.3Z"
                              fill="#FF6F00"
                            />
                            <path
                              d="M21 11C20.4 11 20 11.4 20 12C20 16.4 16.4 20 12 20C7.6 20 4 16.4 4 12C4 9.9 4.8 7.9 6.3 6.4C7.8 4.8 9.8 4 12 4C12.6 4 13.3 4.1 13.9 4.2C14.4 4.4 15 4.1 15.2 3.5C15.4 2.9 15 2.5 14.5 2.3H14.4C13.6 2.1 12.8 2 12 2C6.5 2 2 6.5 2 12.1C2 14.7 3.1 17.3 4.9 19.1C6.8 21 9.3 22 11.9 22C17.4 22 21.9 17.5 21.9 12C22 11.4 21.5 11 21 11Z"
                              fill="#FF6F00"
                            />
                          </svg>
                        </div>
                        <div className="sort-list-desc">
                          {totalText || totalBookNowText}{" "}
                          <span>
                            {" "}
                            $
                            {location.pathname === "/"
                              ? typeof discountedTotalHome === "number" &&
                                couponCode
                                ? discountedTotalHome
                                : finalPrice
                              : typeof discountedTotalBookNow === "number" &&
                                couponCode
                              ? discountedTotalBookNow
                              : bookfinalPrice}
                          </span>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className=" mb-3">
                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="termsCheckbox"
                      checked={isChecked}
                      onChange={handleCheckboxChange}
                    />
                    <label
                      className="login-linkpara mb-0"
                      htmlFor="termsCheckbox"
                    >
                      {agreeCheckbox || agreeBookNowCheckbox}{" "}
                      <Link
                        to="/terms-and-conditions"
                        className="custom-loginlink"
                      >
                        {termsConditionCheckbox ||
                          termsConditionBookNowCheckbox}
                      </Link>
                      {/* . */}
                    </label>{" "}
                  </div>
                  {isCheckedError && (
                    <div className="validation-error">{isCheckedError}</div>
                  )}
                </div>

                <p className="paymet-desc">
                  {verifyDescription || verifyBookNowDescription}
                </p>

                <p className="paymet-desc">
                  {verifymessageDescription || verifymessageBookNowDescription}
                </p>
                <p className="text-center payment-pricepara">
                  {payingHeading || payingBookNowHeading}{" "}
                  <strong className="payment-price">
                    $
                    {location.pathname === "/"
                      ? typeof discountedTotalHome === "number" && couponCode
                        ? discountedTotalHome
                        : `${finalPrice}.`
                      : typeof discountedTotalBookNow === "number" && couponCode
                      ? discountedTotalBookNow
                      : `${bookfinalPrice}.`}
                  </strong>{" "}
                  {serviceHeading || serviceBookNowHeading}
                </p>
                {formErrorMessage && (
                  <div className="validation-error">{formErrorMessage}</div>
                )}
                {(location.pathname === "/" && loading) || bookNowloading ? (
                  <>
                    {" "}
                    <button
                      className="success-orangebtn"
                      type="button"
                      disabled
                    >
                      <span
                        className="spinner-border spinner-border-sm me-1 custom-spinner"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Loading...
                    </button>
                  </>
                ) : (
                  <button
                    type="submit"
                    disabled={!stripe}
                    className="success-orangebtn"
                  >
                    Book Now
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>
      </>
      {/* )} */}
    </>
  );
};

export default PaymentForm;
